export default "__VITE_ASSET__Bt5oXeP9__"